/**
 *  Excel导出封装 
 */

import axios from 'axios'
import {
    Message
} from 'element-ui'

//导出数据、导入模板
function _exportMethods(data) {
    axios({
        method: data.method,
        url: data.url,
        data: data.data || {},
        responseType: 'blob'
    }).then((res) => {
        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
        // let fileNames = res.headers['content-type']

        console.log(res, fileNames, "导出数据、导入模板");

        let regFileNames = fileNames.match(/=utf-8''(.*)$/)[1]; //截取header头中的文件名称

        const link = document.createElement('a')
        //数据的类型和type设置的类型必须一致，是二进制文件
        let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
        })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = decodeURIComponent(regFileNames) //解码下载的文件名
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }).catch(error => {
        Message({
            message: '网络连接错误!',
            type: 'error',
            duration: 5 * 1000
        })
        console.log(error)
    })
}

export default _exportMethods